<template>

  <div class="p-col-12">

    <form @submit.prevent="save" id="annotation-form">
      <coff-input-text-editor v-model="annotation" label="forms.annotation-card.annotation" :content_css="content_css" :skin="skin"/>
      <div>
        <Button :label="$t('btn.cancel')" @click.prevent="cleanForm()" type="button" class="p-mt-2 p-ml-auto p-button-outlined p-button-secondary" v-if="editing" />
        <Button :label="$t('btn.save')" class="p-mt-2 float-right p-mb-2 p-button-success" :disabled="isAnnotationEmptyNullOrUndefined"/>
      </div>
    </form>

    <div v-for="(item, index) in annotations" :key="index" class="p-d-flex p-col-12 line-content p-mb-2">
      <div class="p-col-1">
        <image-from-server class="avatar p-mr-2 float-left" :src="item.user.avatar" />
      </div>
      <div class="p-col-10">
        <span class="text-muted">{{item.user.name}} - {{$d(new Date(item.created), 'long')}} {{item.updated ? ` - ${$t('forms.annotation-card.updated')}: ${$d(new Date(item.updated), 'long')}` : ''}}</span>
        <div class="p-mt-1">
          <span v-html="item.annotation" class="annotation-text" :title="item.annotation"/>
        </div>
      </div>
      <div class="p-col-1 p-text-right text-vertical-center" v-if="loggedUser.id === item.user.id">
        <a class="cursor-pointer" @click.prevent="editAnnotation(item)"><i class="p-ml-2 pi pi-pencil small" :title="$t('forms.annotation-card.edit')"/></a>
        <a class="cursor-pointer" @click.prevent="remove(item)"><i class="p-ml-2 pi pi-times small" :title="$t('forms.annotation-card.delete')"/></a>
      </div>
    </div>

  </div>

</template>

<script>
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import ImageFromServer from "@/components/image/ImageFromServer";
import Utils from "@/utils/Utils";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import store from "@/store";

export default {

  name: "Annotation",
  components: {ImageFromServer},
  props:{
    entity: {type: Object, default: () => {}},
    business: {type: Object, default: () => {}},
  },

  data(){
    return {
      loggedUser: store.getLoggedUser(),
      annotation: '',
      annotations: [],
      editing: null,
      content_css: null,
      skin: null,
      dark: 'dark',
    }
  },

  computed:{

    isAnnotationEmptyNullOrUndefined() {
      return Utils.isEmptyNullOrUndefined(this.annotation.trim());
    }

  },

  created() {
    if(store.getLayoutColor() === this.dark){
      this.content_css = 'dark';
      this.skin = 'oxide-dark';
    }
  },

  async mounted() {
    await this.getAnnotations();
  },

  methods:{

    async editAnnotation(item){
      this.editing = item;
      this.annotation = item.annotation;
      const el = this.$el.querySelector("#annotation-form");
      el.scrollIntoView({behavior: 'smooth', block: "center" });
    },

    cleanForm(){
      this.annotation = '';
      this.editing = null;
    },

    async save(){
      if(this.editing){
        await this.edit();
      } else {
        await this.creat();
      }
    },

    async edit(){
      const response = await this.business.edit(this.annotation, this.editing.id).catch((e) => ToastMessageBusiness.showError(e.message));
      if(response){
        this.editing.annotation = this.annotation;
        this.cleanForm();
      }
    },

    async creat(){
      const response = await this.business.save(this.annotation, this.entity.id).catch((e) => ToastMessageBusiness.showError(e.message));
      if(response){
        this.annotations.unshift(response);
        this.cleanForm();
      }
    },

    async getAnnotations(){
      const annotations = await this.business.getAll(this.entity.id).catch((e) => ToastMessageBusiness.showError(e.message));
      if(annotations){
        this.annotations = annotations;
      }
    },

    async remove(annotation){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await this.business.delete(annotation.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.annotations = this.annotations.filter(a => a.id !== annotation.id);
          this.cleanForm();
        }
      }
    },

  }

}
</script>

<style scoped>

  .avatar {
    width: 55px;
    border-radius: 80px;
  }

  .annotation-text {
    overflow: hidden;
    white-space:break-spaces;
    text-overflow:ellipsis;
    width:100%;
    display:inline-block;
  }

</style>